export default "__VITE_ASSET__BOoARucC__"